import './TopFilter.less';

//import Collapse from 'bootstrap';
import Sumoselect from '../../libs/jquery.sumoselect';
import _ from 'lodash';
import axios from 'axios';

const topFilter = (() => {
	let topFilter = document.querySelector('#js-top-filter');
	let topMenu = document.querySelector('#js-top-menu');
	let searchForm = document.querySelector('#js-search-form');
	
	searchForm.addEventListener('submit', function (e) {
		let fakePhrase = document.querySelector('#js-fake-loc-phrase');
		let input = document.querySelector('#js-search-container');
		fakePhrase.value = input.value;
		console.log('onSubmit', input.value);
	})
	
	function formatNumber(num) {
		return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
	}
	
	const handleSearch = () => {
		let searchTogglers = Array.from(document.querySelectorAll('.js-toggle-filters'));
		
		const toggleFilters = () => {
			topMenu.classList.toggle('lower-z-index');
			topFilter.classList.toggle('opened');
		};
		
		searchTogglers.forEach(toggler => {
			toggler.addEventListener('click', toggleFilters);
		});
	};
	
	const changeBg = src => {
		let filterBg = document.querySelector('#js-filter-bg');
		
		filterBg.classList.add('faded');
		setTimeout(() => {
			filterBg.setAttribute('src', src);
			setTimeout(() => {
				filterBg.classList.remove('faded');
			}, 200);
		}, 300);
	};
	
	const filterFields = type => {
		let filtrables = Array.from(document.querySelectorAll('.filtrable'));
		filtrables
			.map(field => {
				if (field.classList.contains('SumoUnder')) {
					field.removeAttribute('disabled');
					field.classList.remove('hidden');
					field.parentElement.classList.remove('hidden')
				} else {
					field.classList.remove('hidden');
					field.removeAttribute('disabled');
					let input = field.querySelectorAll('input');
					input.forEach(input => {
						input.removeAttribute('disabled', 'disabled');
					});
				}
				return field;
				
			})
			.filter(field => field.dataset.hidein.includes(type))
			.forEach(field => {
				if (field.classList.contains('SumoUnder')) {
					field.setAttribute('disabled', 'disabled');
					field.classList.add('hidden');
					field.parentElement.classList.add('hidden');
				} else {
					field.classList.add('hidden');
					let input = field.querySelectorAll('input');
					input.forEach(input => {
						input.setAttribute('disabled', 'disabled');
					});
					field.setAttribute('disabled', 'disabled');
				}
			});
	};
	
	const getSelectedAttr = (select, attr) => select.options[select.selectedIndex][attr];
	
	const getSelectedDatasetAttr = (select, attr) => select.options[select.selectedIndex].dataset[attr];
	
	const changeHeader = selectedOption => {
		let titles = {
			"title": document.querySelector('#js-filter-title'),
			"subtitle": document.querySelector('#js-filter-subtitle')
		};
		
		let title_split = selectedOption.split(' - ');
		
		titles.title.innerText = title_split[0];
		titles.subtitle.innerText = title_split[1] || "";
	};
	
	const initializeStandardSelects = () => {
		$(document).ready(function () {
			let standardSelects = ['.js-type', '.js-floors'];
			
			standardSelects.forEach(select => {
				let elem = $(select);
				let elemConfig = {};
				
				if (elem.data('placeholder') != "") {
					elemConfig = {placeholder: elem.data('placeholder')};
				}
				elem.SumoSelect(elemConfig);
			});
			let type = document.querySelector('#js-type');
			if (type) {
				filterFields(getSelectedDatasetAttr(type, 'type'));
			}
		});
	};
	
	const initOnChangeEvents = () => {
		
		document.getElementsByName('object')[0].addEventListener('change', e => {
			changeBg(getSelectedDatasetAttr(e.currentTarget, 'img'));
			changeHeader(getSelectedAttr(e.currentTarget, 'text'));
			filterFields(getSelectedDatasetAttr(e.currentTarget, 'type'));
		});
	};
	
	
	const initLocalizationSelect = () => {
		const searchContainer = document.querySelector('#js-search-container');
		const selectTrigger = document.querySelector('#js-fake-loc-caption');
		const submenuTriggers = Array.from(document.querySelectorAll('.js-submenu-trigger'));
		const mainMenu = document.querySelector('#js-main-submenu');
		const selectData = document.querySelector('#js-fake-loc-data');
		let submenuBacks = Array.from(document.querySelectorAll('.js-submenu-back'));
		let submenus = Array.from(document.querySelectorAll('.fake-loc-input__submenu-wrapper'));
		const dataGetters = Array.from(document.querySelectorAll('.js-get-loc'));
		
		const closeSubmenus = () => submenus.forEach(submenu => submenu.classList.remove('active'));
		
		selectTrigger.addEventListener('click', e => {
			selectData.classList.contains('active')
				? mainMenu.classList.remove('active')
				: mainMenu.classList.add('active');
			
			selectData.classList.toggle('active');
			
			closeSubmenus();
			
		});
		
		let closeCities = document.querySelectorAll('.fake-loc-input__list-elem');
		
		closeCities.forEach(closeCity => {
			closeCity.addEventListener('click', e => {
				if (mainMenu.classList.contains('active')) {
					mainMenu.classList.remove('active');
				}
			});
		});
		
		document.addEventListener('click', e => {
			if (e.target !== selectTrigger && e.target.classList.contains('js-submenu-trigger') === false && e.target.classList.contains('js-submenu-back') === false) {
				selectData.classList.remove('active');
			}
		});
		
		const insertLocInputs = data => {
			let inputIDs = ['js-fake-loc-province', 'js-fake-loc-location', 'js-fake-loc-quarter'];
			let extractedLocations = data.split(',');
			
			const setValue = (elem, value) => {
				try {
					document.getElementById(elem).value = value;
				} catch (e) {
					console.log(e);
				}
			};
			
			for (let i = 0; i < inputIDs.length; i++) {
				let value = extractedLocations[i] || "";
				
				if (inputIDs[i]) {
					setValue(inputIDs[i], value);
				}
			}
		};
		
		dataGetters.forEach(getter => {
			getter.addEventListener('click', e => {
				searchContainer.value = e.currentTarget.dataset.insert;
				insertLocInputs(e.currentTarget.dataset.insert);
			});
		});
		
		const isParentSubmenuWrapper = elem => elem.closest('ul').parentElement.classList.contains('fake-loc-input__submenu-wrapper');
		
		submenuTriggers.forEach(trigger => {
			trigger.addEventListener('click', e => {
				e.currentTarget.closest('ul').classList.remove('active');
				
				if (isParentSubmenuWrapper(e.currentTarget)) {
					e.currentTarget.closest('ul').parentElement.classList.remove('active');
				}
				
				document.getElementById(e.currentTarget.dataset.submenu).classList.add('active');
			});
		});
		
		submenuBacks.forEach(back => {
			back.addEventListener('click', e => {
				e.currentTarget.closest('.fake-loc-input__submenu-wrapper').classList.remove('active');
				document.getElementById(e.currentTarget.dataset.parent).classList.add('active');
			});
		});
	};
	
	const initOnRentSwitch = () => {
		let switchers = Array.from(document.querySelectorAll('.js-isrent'));
		let offerTypeInput = document.getElementById('offerType');
		switchers.forEach(switcher => {
			
			switcher.addEventListener('click', e => {
				document.getElementById('offerType').value = switcher.dataset.rent;
				// console.log(offerTypeInput + '||' + switcher.dataset.rent);
				
				e.currentTarget.dataset.rent == 1
					? $('select#js-type')[0].sumo.disableItem(1)
					: $('select#js-type')[0].sumo.enableItem(1);
			});
			
		});
	};
	
	const initAutocomplete = () => {
		let input = document.querySelector('#js-search-container');
		let resultsContainer = document.querySelector('#js-search-results');
		let fakePhrase = document.querySelector('#js-fake-loc-phrase');
		
		const CancelToken = axios.CancelToken;
		const source = CancelToken.source();
		
		const fetchListData = value => {
			let form = $('#js-search-form');
			let data = form.serialize();
			// return axios.get(`autocomplete/${value}`, {cancelToken: source.token});
			return axios.post(`autocomplete/${value}`, data);
		};
		
		const addResultListener = () => {
			
			let datasets = ['province', 'location', 'quarter', 'type'];
			let locations = Array.from(document.querySelectorAll('.js-search-result'));
			
			fakePhrase.value = input.value;
			console.log('updated', input.value);
			
			locations.forEach(location => {
				location.addEventListener('click', e => {
					fakePhrase.value = input.value;
					input.value = `${e.currentTarget.children[0].innerText}`;
					datasets.forEach(data => {
						document.querySelector(`#js-fake-loc-${data}`).value = location.dataset[data];
						console.log('updated', `#js-fake-loc-${data}`, location.dataset[data]);
					});
					console.log('updated', input.value);
					
					resultsContainer.classList.add('hidden');
				});
			});
		};
		
		const getValues = (e, target) => {
			
			document.querySelector(`#js-fake-loc-province`).value = '';
			document.querySelector(`#js-fake-loc-location`).value = '';
			document.querySelector(`#js-fake-loc-quarter`).value = '';
			document.querySelector(`#js-fake-loc-type`).value = '';
			document.querySelector(`#js-fake-loc-phrase`).value = '';
			//  source.cancel('Aborted request');
			fetchListData(target.value)
				.then(response => {
					resultsContainer.innerText = "";
					response.data.suggestions.forEach(result => {
						let li = document.createElement('li');
						li.classList.add('js-search-result');
						if (result.class !== undefined) {
							li.classList.add(result.class);
						}
						li.innerHTML = result.label;
						li.dataset.province = result.province;
						li.dataset.location = result.location || "";
						li.dataset.quarter = result.quarter || "";
						li.dataset.offers = result.offers || "";
						li.dataset.type = result.type || "general";
						resultsContainer.appendChild(li);
					});
					resultsContainer.classList.remove('hidden');
					addResultListener();
					
				})
				.catch(function (response) {
					console.log(response);
				});
		};
		
		let debounced = _.debounce(getValues, 200);
		input.addEventListener('keyup', (e) => debounced(e, e.currentTarget));
		
		document.addEventListener('click', () => {
			resultsContainer.classList.add('hidden');
		});
	};
	
	const convertToLocale = () => {
		let convertible = Array.from(document.querySelectorAll('.js-to-locale'));
		
		convertible.forEach(input => {
			
			input.addEventListener('keyup', e => {
				let value = e.currentTarget.value.replace(/\s/g, "");
				e.currentTarget.value = formatNumber(value);
			});
			
		});
	};
	
	const boot = () => {
		initializeStandardSelects();
		initLocalizationSelect();
		handleSearch();
		initOnChangeEvents();
		initOnRentSwitch();
		initAutocomplete();
		convertToLocale();
	};
	
	boot();
	
})();

export default topFilter;